import { sendPost } from "src/utils/sendApi";

export const fetchUnitList = sendPost("v1/data/_list_unit");
export const conversion = sendPost("v1/data/_unit");
